/**
 * * Модель данных о положении обрезки
 */
export class CropSelectionModel {
  X: number = 0;
  Y: number = 0;
  Width: number = 0;
  Height: number = 0;
  DestinationWidth: number = 0;
  DestinationHeight: number = 0;

  constructor(
    x: number,
    y: number,
    width: number,
    height: number,
    destinationWidth?: number,
    destinationHeight?: number,
  ) {
    this.X = x;
    this.Y = y;
    this.Height = height;
    this.Width = width;
    this.DestinationHeight = destinationHeight || 0;
    this.DestinationWidth = destinationWidth || 0;
  }
}
